import React from 'react'
import keys from 'lodash/keys'
import upperFirst from 'lodash/upperFirst'
import { compose } from 'recompose'
import withEditPage from 'hocs/extends/withEditPage'
import withFetchResources from 'hocs/bases/withFetchResources'
import CmsApis from 'apis/cmsApis'
import PageContent from 'components/wrappers/PageContent'
import Paper from 'material-ui/Paper'
import FormSelect from 'components/forms/bases/FormSelect'
import MainHeader from 'components/headers/MainHeader'
import { updateObject } from 'helpers/objectHelpers'
import StateToolbar from 'components/bars/StateToolBar'

const styles = {
  wrapper: {
    display: 'flex',
    marginLeft: 30,
    marginBottom: 10,
  },
  label: {
    width: '10%',
    margin: '0px 30px 0 20px',
    fontWeight: 400,
  }
}

const MenuLocations = compose(
  withFetchResources({
    resourceName: 'menus',
    getAction: () => CmsApis.getMenus,
  }),
  withEditPage({
    resourceName: 'staticMenus',
    getFetchAction: () => CmsApis.getStaticMenus,
    getUpdateAction: () => CmsApis.updateStaticMenus,
  }),
)(
  ({
    staticMenus,
    onChange,
    menus,
    fetchMenusStatus,
    isStateChanged,
    setIsStateChanged,
    onDiscardChange,
    onSave,
    saveStatus,
  }) => {
    const handleChange = (val, key) => {
      setIsStateChanged(true)
      return onChange(updateObject(staticMenus, { [key]: val }))
    }
    return (
      <PageContent>
        <Paper>
          <StateToolbar
            primary={isStateChanged}
            isStateChanged={isStateChanged}
            onDiscard={() => {
              setIsStateChanged(false)
              return onDiscardChange()
            }}
            onSave={onSave}
            saveStatus={saveStatus}
          />
          <PageContent>
            <MainHeader>Menu Locations</MainHeader>
            {
              keys(staticMenus).map((key, i) => {
                return (
                  <div key={i} style={styles.wrapper}>
                    <h3 style={styles.label}>{upperFirst(key)}</h3>
                    <FormSelect
                      disabled={fetchMenusStatus.isRequest}
                      label={fetchMenusStatus.isRequest ? 'Loading...' : ''}
                      value={fetchMenusStatus.isRequest ? '' : staticMenus[key]}
                      onChange={(val) => handleChange(val, key)}
                      options={
                        menus.map(({ id, name }) => ({ label: name, value: id }))
                      }
                    />
                  </div>
                )
              })
            }
          </PageContent>
        </Paper>
      </PageContent>
    )
  }
)

MenuLocations.propTypes = {}
MenuLocations.defaultProps = {}

export default MenuLocations



// WEBPACK FOOTER //
// ./src/pages/Menus/children/MenuLocations.js